import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import slugme from "slugme";
import InsLoader from "../../../../components/InsLoader/InsLoader";
import parse from "html-react-parser";
import InsHeaderFormationsIndex from "../../../../components/InsHeaderFormationsIndex/InsHeaderFormationsIndex";

import "./FormationIndex.scss";
import { getTraining } from "../../../../api/training";
import InsComments from "../../../../components/InsComments/InsComments";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { addLike } from "../../../../api/training";

export class FormationIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      loader: true,
      formationInfos: {},
      courseId: this.getLast(this.props.match.params.id.split("-")),
      lng: this.props.i18n.language,
    };
  }

  UNSAFE_componentWillMount() {
    document.body.classList.add("formation-index");
    this.getFormation();
  }

  componentWillUnmount() {
    document.body.classList.remove("formation-index");
  }

  componentDidUpdate() {
    if (this.state.lng !== this.props.i18n.language) {
      this.setState({ lng: this.props.i18n.language });
      this.getFormation();
    }
  }

  // Recupére le dernier element d'un tableau
  getLast = (array) => array[array.length - 1];

  /**
   * Récupere les informations de la formation
   */
  getFormation() {
    this.setState({ loader: true });
    const { courseId } = this.state;
    getTraining(courseId)
      .then((data) => {
        this.setState({
          formationInfos: data,
          loader: false,
          alreadyLink: null,
        });
      })
      .catch((err) => {
        this.setState({ redirect: true });
      });
  }

  addCourseLike = () => {
    const { courseId } = this.state;
    addLike(courseId).then((data) => {
      this.setState((prevState) => ({
        formationInfos: {
          ...prevState.formationInfos,
          ...data,
        },
      }));
    });
  };

  alreadyDone(e, course, type) {
    e.preventDefault();
    this.setState({ alreadyLink: course, alreadyLinkType: type });
  }

  render() {
    const { account, match, t } = this.props;
    const { formationInfos, redirect } = this.state;
    const {
      isLiked,
      picture,
      brand,
      points,
      likes,
      title,
      description,
      module_groups,
    } = formationInfos;
    const style = {
      backgroundImage: "url(" + picture + ")",
    };

    if (redirect) {
      return <Redirect to="/" />;
    }

    if (this.state.loader) {
      return (
        <div className="formation_desc">
          <InsLoader />
        </div>
      );
    }

    return (
      <>
        <InsHeaderFormationsIndex
          isLiked={isLiked}
          likes={likes}
          addLike={this.addCourseLike}
        />
        <div className="formation_desc">
          <div className="formation_desc-img" style={style}></div>
          <div className="formation_infos">
            {points && <div className="formation_points">{"+" + points}</div>}
            <div className="formation_brand">{brand}</div>
            <div className="formation_title">{title}</div>
            <div className="formation_short_desc">
              {description ? parse(description) : null}
            </div>
          </div>
          <div className="formation_modules">
            {module_groups.map((module, index) => {
              // console.log(module.name, index);
              if (!module.name) {
                // La traduction n'est pas disponible
                return <React.Fragment key={index} />;
              }
              const moduleSlug = slugme(module.name) + "-" + module.id;
              const type = module.type;
              return (
                <Link
                  key={index}
                  className="module_link"
                  to={{
                    pathname:
                      match.url +
                      `${match.url[match.url.length - 1] === "/" ? "" : "/"}` +
                      moduleSlug +
                      (type === "scorm" ? "/scorm" : ""),

                    state: { transitionName: "slide_in" },
                  }}
                  onClick={
                    module.correct
                      ? (e) => this.alreadyDone(e, moduleSlug, type)
                      : null
                  }
                >
                  <div className={"module module" + module.id}>
                    <div
                      className={
                        module.correct ? "module_name checked" : "module_name"
                      }
                    >
                      {module.name}
                    </div>
                    <div className="module_time">
                      <div className="time">
                        {module.time ? module.time : 0}
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
          <div className="comments">
            <InsComments
              currentUserAvatar={account.picture}
              contentId={formationInfos.id}
              callApi="formations"
            />
          </div>
          <div
            className={
              this.state.alreadyLink === null
                ? "already_done"
                : "already_done active"
            }
          >
            <div className="already_done--wrapper">
              <p className="already_done_title">
                {t("formation_already_completed")}
              </p>
              <p>{t("formation_already_completed_text")}</p>
              <p>{t("want_to_continue")}</p>
              <div className="already_done_chooser">
                <Link
                  to={{
                    pathname:
                      match.url +
                      `${match.url[match.url.length - 1] === "/" ? "" : "/"}` +
                      this.state.alreadyLink +
                      (this.state.alreadyLinkType === "scorm" ? "/scorm" : ""),
                    state: { transitionName: "slide_in" },
                  }}
                >
                  <div className="already_done_chooser--btn">{t("yes")}</div>
                </Link>
                <div
                  className="already_done_chooser--btn"
                  onClick={() => this.setState({ alreadyLink: null })}
                >
                  {t("no")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

//extract data from the redux store
const mapStateToProps = (state) => ({
  account: state.account,
});

export default connect(mapStateToProps)(withTranslation()(FormationIndex));
